import { Component } from "modular-openscriptjs";
import { disposeBootstrapTree } from "../helpers";

export default class ModalComponent extends Component {
	cleanUp() {
		super.cleanUp();
		let markup = this.markup();

		for (let elem of markup) {
			disposeBootstrapTree(elem);
		}
	}
}